import { breakpoints } from '../utils';
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default function () {
  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

  const container = document.querySelector('.horizontal-scroll');

  let mm = gsap.matchMedia();

  if (!container) {
    return;
  }

  mm.add(`(min-width: ${breakpoints.md}px)`, () => {
    const sections = container.querySelectorAll('.panel');

    const panels = Array.from(sections).map((s) => s.offsetWidth);
    const containerWidth = panels.reduce((total, current) => {
      return total + current;
    }, 0);

    const isMobile = () => {
      return window.matchMedia('screen and (max-width: 767px)').matches;
    };

    // 100 = gradient width
    const snapPoints = isMobile()
      ? [0, 0.25, 0.5, 0.75, 1]
      : [
          0,
          panels[1] / (containerWidth - window.innerWidth),
          (panels[1] + panels[2] + panels[3] - 100) / (containerWidth - window.innerWidth),
          1
        ];

    gsap.to(sections, {
      x: () => {
        const containerWidth = Array.from(sections)
          .map((s) => s.offsetWidth)
          .reduce((total, current) => {
            return total + current;
          }, 0);
        return -containerWidth + window.innerWidth;
      },
      ease: 'none',
      scrollTrigger: {
        trigger: container,
        pin: true,
        scrub: 1,
        snap: {
          snapTo: snapPoints,
          duration: { min: 0.2, max: 1 },
          delay: 0.1,
          inertia: false
        },
        // base vertical scrolling on how wide the container is so it feels more natural.
        start: 'top top',
        end: () => Math.max(window.innerHeight, window.innerWidth) * 2 + ' top',
        invalidateOnRefresh: true // to make it responsive
      }
    });

    container.querySelectorAll('a,button').forEach((button) => {
      button.addEventListener('focus', (e) => {
        e.preventDefault();
        const currentPanel = e.currentTarget.closest('.panel');
        const pinSpacer = container.closest('.pin-spacer');
        const index = [...sections].indexOf(currentPanel);
        let snap = 0;
        if (isMobile()) {
          snap = snapPoints[index];
        } else {
          if (index > 0 && index <= 1) {
            snap = snapPoints[1];
          } else if (index >= 2 && index <= 3) {
            snap = snapPoints[2];
          } else {
            snap = 1;
          }
        }
        gsap.to(window, {
          scrollTo: {
            y:
              pinSpacer.getBoundingClientRect().top +
              window.scrollY +
              (pinSpacer.getBoundingClientRect().height - window.innerHeight) * snap
          },
          duration: 0.6,
          ease: 'power1.out'
        });
      });
    });
  });
}
